const PETITION_SIGNING_STATES = {
  OPEN: 'open',
  CLOSED: 'closed',
};

const fieldsListView = new Set([
  'petition_code',
  'subject',
  'state',
  'sent_timestamp',
  'target',
  'sign_count',
  'sign_status',
  // This is an object with one child attribute
  'trending',
]);

const fieldsFullPetition = new Set([
  'petition_code',
  'subject',
  'message',
  'petitioner_name',
  'petitioner_code',
  'state',
  'sent_timestamp',
  'target',
  'sign_count',
  'sign_status',
  // This is an object with one child attribute
  'trending',
]);

const trimPetitions = ({ petitions = [], fieldsToKeep }) => {
  const trimmedPetitions = new Array(petitions.length);
  petitions.forEach((p, idx) => {
    const slimPetition = {};
    fieldsToKeep.forEach((f) => {
      const fieldValue = p[f];
      if (fieldValue) {
        slimPetition[f] = fieldValue;
      }
    });
    trimmedPetitions[idx] = slimPetition;
  });
  return trimmedPetitions;
};

export {
  PETITION_SIGNING_STATES,
  fieldsListView,
  fieldsFullPetition,
  trimPetitions,
};
